<script setup lang="ts"></script>

<template>
  <p class="font-pragmatica-ext text-2xl font-bold">
    <slot />
  </p>
</template>
